/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { airbnb } from './channel-logos/Airbnb';
import { bookingcom } from './channel-logos/Bookingcom';
import { expedia } from './channel-logos/Expedia';
import { holidu } from './channel-logos/Holidu';
import { tripadvisor } from './channel-logos/TripAdvisor';
import { vrbo } from './channel-logos/Vrbo';
import { travelnest } from './channel-logos/Travelnest';
import { hometogo } from './channel-logos/HomeToGo';
export const channelLogoLookup = {
    airbnb,
    bookingcom,
    expedia,
    holidu,
    tripadvisor,
    vrbo,
    travelnest,
    hometogo,
};
//# sourceMappingURL=channel-logo-lookup.js.map